// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_IjyT9 {
  width: 504px;
}
.container_JT4Dh {
  border : 1px solid var( --color-base200 );
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  background-color : var( --color-white );
}

.devicesList_dxoJk {
  list-style-type: none; 
  margin: 0; 
  padding: 0; 
  background-color: var(--color-white);
}

.locatorLabel_UiQWk {
  align-items: center !important;
  background-color: var(--color-white);
}

.close_t_3bI {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.bar_H9YZL {
  border-style : solid;
  border-width : 1;
  border-color : var(--color-base200);
  border-bottom : none;
  width : 100%;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/location/VehicleTransferLocation.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mCAAmC;EACnC,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".dialog {\n  width: 504px;\n}\n.container {\n  border : 1px solid var( --color-base200 );\n  padding: 10px;\n  margin-top: 10px;\n  border-radius: 5px;\n  background-color : var( --color-white );\n}\n\n.devicesList {\n  list-style-type: none; \n  margin: 0; \n  padding: 0; \n  background-color: var(--color-white);\n}\n\n.locatorLabel {\n  align-items: center !important;\n  background-color: var(--color-white);\n}\n\n.close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.bar {\n  border-style : solid;\n  border-width : 1;\n  border-color : var(--color-base200);\n  border-bottom : none;\n  width : 100%;\n  margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_IjyT9`,
	"container": `container_JT4Dh`,
	"devicesList": `devicesList_dxoJk`,
	"locatorLabel": `locatorLabel_UiQWk`,
	"close": `close_t_3bI`,
	"bar": `bar_H9YZL`
};
export default ___CSS_LOADER_EXPORT___;
